import { ofType } from 'redux-observable';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { push } from 'connected-react-router';
import {
  ADD_CLAIM_TO_SAISINE_REQUEST,
  addSaisineError,
  addSaisineSuccessFlag,
  AUTOFILL_APPLY_REQUEST,
  AUTOFILL_PREVIEW_REQUEST,
  autofillApplyResponse,
  autofillPreviewResponse,
  CREATE_SAISINE_REQUEST,
  createSaisineResponse,
  DELETE_SAISINE_REQUEST,
  deleteSaisineResponse,
  GENERATE_SAISINE_DOCS_REQUEST,
  generateSaisineDocsResponse,
  REMOVE_CLAIM_FROM_SAISINE_REQUEST,
  RETRIEVE_SAISINE_REQUEST,
  RETRIEVE_SAISINES_REQUEST,
  retrieveSaisineResponse,
  retrieveSaisines as retrieveSaisinesAction,
  retrieveSaisinesError,
  retrieveSaisinesResponse,
  SEARCH_ELIGIBLE_CLAIMS_REQUEST,
  searchEligibleClaimsResponse,
  VALIDATE_SAISINE_REQUEST,
} from './saisine.actions';

export const retrieveSaisines = (action$, store, { SaisineGateway }) => action$.pipe(
  ofType(RETRIEVE_SAISINES_REQUEST),
  mergeMap((action) => SaisineGateway.retrieveSaisines(action.payload)
    .pipe(
      map((data) => retrieveSaisinesResponse(data)),
      catchError((error) => of(retrieveSaisinesError(error.response))),
    )),
);

export const retrieveSaisine = (action$, store, { SaisineGateway }) => action$.pipe(
  ofType(RETRIEVE_SAISINE_REQUEST),
  mergeMap((action) => SaisineGateway.retrieveSaisineById(action.payload)
    .pipe(
      map((data) => retrieveSaisineResponse(data)),
      catchError((error) => of(addSaisineError(error.response))),
    )),
);

export const createSaisine = (action$, store, { SaisineGateway }) => action$.pipe(
  ofType(CREATE_SAISINE_REQUEST),
  mergeMap((action) => SaisineGateway.createSaisine(action.payload)
    .pipe(
      mergeMap((data) => of(
        createSaisineResponse(data),
        push(`/saisine?id=${data.saisine._id}`),
      )),
      catchError((error) => of(addSaisineError(error.response))),
    )),
);

export const addClaimToSaisine = (action$, store, { SaisineGateway }) => action$.pipe(
  ofType(ADD_CLAIM_TO_SAISINE_REQUEST),
  mergeMap((action) => SaisineGateway.addClaim(action.payload.saisineId, action.payload.claimId)
    .pipe(
      map((data) => retrieveSaisineResponse(data)),
      catchError((error) => of(addSaisineError(error.response))),
    )),
);

export const removeClaimFromSaisine = (action$, store, { SaisineGateway }) => action$.pipe(
  ofType(REMOVE_CLAIM_FROM_SAISINE_REQUEST),
  mergeMap((action) => SaisineGateway.removeClaim(action.payload.saisineId, action.payload.claimId)
    .pipe(
      map((data) => retrieveSaisineResponse(data)),
      catchError((error) => of(addSaisineError(error.response))),
    )),
);

export const deleteSaisine = (action$, store, { SaisineGateway }) => action$.pipe(
  ofType(DELETE_SAISINE_REQUEST),
  mergeMap((action) => SaisineGateway.deleteSaisine(action.payload)
    .pipe(
      mergeMap(() => of(
        deleteSaisineResponse(),
        push('/saisines?paginateSize=50'),
      )),
      catchError((error) => of(addSaisineError(error.response))),
    )),
);

export const validateSaisine = (action$, store, { SaisineGateway }) => action$.pipe(
  ofType(VALIDATE_SAISINE_REQUEST),
  mergeMap((action) => SaisineGateway.validateSaisine(action.payload)
    .pipe(
      mergeMap((data) => of(
        retrieveSaisineResponse(data),
        addSaisineSuccessFlag('Saisine envoyée : dossiers passés en « Saisine envoyée »'),
      )),
      catchError((error) => of(addSaisineError(error.response))),
    )),
);

export const searchEligibleClaims = (action$, store, { SaisineGateway }) => action$.pipe(
  ofType(SEARCH_ELIGIBLE_CLAIMS_REQUEST),
  mergeMap((action) => SaisineGateway.searchEligibleClaims(action.payload.saisineId, action.payload.text)
    .pipe(
      map((data) => searchEligibleClaimsResponse(data)),
      catchError((error) => of(addSaisineError(error.response))),
    )),
);

export const generateSaisineDocs = (action$, store, { SaisineGateway }) => action$.pipe(
  ofType(GENERATE_SAISINE_DOCS_REQUEST),
  mergeMap((action) => SaisineGateway.generateDocuments(action.payload)
    .pipe(
      map((data) => generateSaisineDocsResponse(data)),
      catchError((error) => of(addSaisineError(error.response))),
    )),
);

export const autofillPreview = (action$, store, { SaisineGateway }) => action$.pipe(
  ofType(AUTOFILL_PREVIEW_REQUEST),
  mergeMap(() => SaisineGateway.autofillPreview()
    .pipe(
      map((data) => autofillPreviewResponse(data)),
      catchError((error) => of(addSaisineError(error.response))),
    )),
);

export const autofillApply = (action$, store, { SaisineGateway }) => action$.pipe(
  ofType(AUTOFILL_APPLY_REQUEST),
  mergeMap((action) => SaisineGateway.autofillApply(action.payload)
    .pipe(
      mergeMap((data) => of(
        autofillApplyResponse({ report: data, applied: action.payload }),
        retrieveSaisinesAction('?paginateSize=50'),
      )),
      catchError((error) => of(addSaisineError(error.response))),
    )),
);
